<template>
  <b-navbar class="cx_global_menu" id="nav2" :toggleable="$api.spMode ? false:'md'" type="dark" variant="dark" fixed="top">
    <b-navbar-toggle target="nav_text_collapse"></b-navbar-toggle>
    <b-navbar-brand to="/"><img height="32px" src="@/assets/s-flow_logo3.png"/></b-navbar-brand>
    <b-collapse is-nav id="nav_text_collapse">
      

      <b-navbar-nav><slot></slot></b-navbar-nav>
      <b-navbar-nav right class="ml-auto"><slot name="right"></slot>
        <!-- <b-nav-text class="cx_global_menu_right">{{ $api.auth.userId }}</b-nav-text> -->
        <!-- <b-nav-item href="#" @click="logout" class="cx_global_menu_item"><i class="material-icons md valign">exit_to_app</i>ログアウト</b-nav-item> -->
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class GlobalMenu extends Vue {
  @Prop() public title!: string;

  public logout() {
    this.$api.auth.logout();
  }
}
</script>

<style lang="scss">
.cx_global_menu {
    z-index : 200; //スタッキングコンテクスト対応(静的なものは500以下に抑える)
    padding-top: 0px;
    padding-bottom: 0px;   
    padding-left:0px;
    padding-right:0px;
  font-size: 15px;
  background-color: #353943;
 
  .cx_spmode & {
    max-height: var(--vh);    
    .navbar-collapse {
      overflow-y: auto;
      max-height: calc(var(--vh) - 42px); //ヘッダ分誤差が出る。100%だと計算されない。     
    }
  }
  .navbar-brand{
    padding-top:0px;
    padding-bottom:0px;
    width:210px;
    min-width:210px;
    height:42px;
    // background-color:#DCDCDC;
    // background-color:#a3cce4;
    background-color:#c3f5b6d0;
    //  background-color:#eefac1;
    display:flex;
    justify-content: center;
    align-items: center;
    margin-right: 0;
    .cx_spmode & {
      flex:1;
    }
  }

  a {
    padding-left: 8px !important;
    padding-right: 8px !important;    
  }
  .navbar-nav  {
    padding-top: 1px;
    padding-bottom: 1px;    
  }
  .b-nav-dropdown {
    // padding-top: 2px;
    // height: 40px;
    span {
      height: 24px;
    }
  }
}
.cx_global_menu i {
  vertical-align: bottom;
  margin: 0px 5px;
}
.cx_global_menu_right {
  margin: 0px 20px;
  white-space: nowrap;
}
</style>
